import React, { type ReactNode, useMemo } from 'react';

import { getColKey } from './Table.helpers';
import { type ColsWidths, type ColumnConfig } from './Table.types';

export interface ColGroupProps<RecordType> {
    colWidths: ColsWidths;
    columns: ColumnConfig<RecordType>[];
}

const ColGroup = <RecordType,>({ colWidths, columns }: ColGroupProps<RecordType>) => {
    const cols = useMemo(() => {
        const result: ReactNode[] = [];
        // We start from the end because all columns before
        // the last column containing a width should have
        // its own col element in the colgroup.
        [...columns].reverse()?.forEach((column) => {
            const colKey = getColKey(column);
            const width = colWidths.get(colKey);
            if (result.length > 0 || (width && !['0', 'auto'].includes(String(width)))) {
                result.unshift(
                    <col key={`col-${colKey}`} data-key={`col-${colKey}`} style={{ width }} />
                );
            }
        });
        return result;
    }, [colWidths, columns]);
    return <colgroup>{cols}</colgroup>;
};

export default ColGroup;
